module.exports = __webpack_public_path__ + "img/list_icon2.1be9b3c7.png";